import {
  Avatar as MuiAvatar,
  Box,
  Breadcrumbs as MuiBreadcrumbs,
  Button as MuiButton,
  Card as MuiCard,
  CardContent as MuiCardContent,
  Chip as MuiChip,
  Divider as MuiDivider,
  Grid as MuiGrid,
  LinearProgress as MuiLinearProgress,
  TextField as MuiTextField,
  Typography as MuiTypography,
  TypographyProps,
} from "@mui/material";
import { spacing, SpacingProps } from "@mui/system";
import { styled } from "@mui/material/styles";

export const Typography = styled(MuiTypography)<TypographyProps>(spacing);
export const TextField = styled(MuiTextField)<{ my?: number }>(spacing);

export const CardContent = MuiCardContent;
export const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

export const Button = styled(MuiButton)(spacing);

export const Card = styled(MuiCard)(spacing);

export const Chip = styled(MuiChip)(spacing);

export const Divider = styled(MuiDivider)(spacing);

export const Grid = styled(MuiGrid)(spacing);

export const LinearProgress = styled(MuiLinearProgress)(spacing);

export const Spacer = styled("div")(spacing);
